import { render, staticRenderFns } from "./parametros.vue?vue&type=template&id=4da58e42"
import script from "./parametros.vue?vue&type=script&lang=js"
export * from "./parametros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports